/**
 * v-reveal —— 滚动进入视口时淡入上移（自 vancheen-b2b 移植为 Vue 2 指令）
 *
 * IntersectionObserver：threshold 0.12 → 添加 .visible → unobserve（只触发一次）
 * 用法：
 *   <div v-reveal />           // 无延迟
 *   <div v-reveal="2" />       // 等价于原 data-delay="2"
 *   <div v-reveal="false" />   // 关闭动效
 */

let observer = null

function getObserver() {
  if (observer) return observer
  observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible')
          observer.unobserve(entry.target)
        }
      })
    },
    { threshold: 0.12 }
  )
  return observer
}

export const reveal = {
  inserted(el, binding) {
    // 显式传 false 表示该元素不需要动效
    if (binding.value === false) return

    el.classList.add('reveal')
    if (binding.value !== undefined && binding.value !== null && binding.value !== '') {
      el.setAttribute('data-delay', String(binding.value))
    }
    if (!('IntersectionObserver' in window)) {
      el.classList.add('visible')
      return
    }
    getObserver().observe(el)
  },
  unbind(el) {
    if (observer) observer.unobserve(el)
  }
}

export default reveal
